export const isSuggestionArchived = (value: unknown): boolean => {
  if (value === true) {
    return true;
  }

  if (value && typeof value === 'object') {
    const candidate = value as Record<string, unknown>;
    if (candidate.isArchived === true) {
      return true;
    }
    const status = String(candidate.status || '')
      .trim()
      .toLowerCase();
    return status === 'archived';
  }

  return false;
};

export const isSuggestionActive = (value: unknown): boolean => !isSuggestionArchived(value);
